import client from '../../utils/api'
import { createSlice } from '@reduxjs/toolkit'
import { createApiAction } from '../../utils/redux-tool'

const name = 'academic-attendance-daily'
const initialState = {}

export const search = createApiAction(
  '/attendance/daily/search',
  client.search('/api/attendance/daily'),
)
export const save = createApiAction('attendance/daily/save', client.save('/api/attendance/daily'))

export const update = createApiAction(
  'attendance/daily/update',
  client.update('/api/attendance/daily/:id'),
)

export const destroy = createApiAction(
  'attendance/daily/delete',
  client.destroy('/api/attendance/daily/:id'),
)

const sessionSlice = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(search.fulfilled, (state, action) => {
      state.status = action.payload.status
    })
    builder.addCase(save.fulfilled, (state, action) => {
      state.status = action.payload.status
    })
  },
})

export default sessionSlice.reducer
